import React from 'react';
import PropTypes from 'prop-types';
import Iframe from '../shared/Iframe';

/**
 * Google Maps component
 *
 * @param props
 * @returns {XML}
 * @constructor
 */
const GoogleMaps = props => {
  const url = `${props.params.ludus.url}&zoom=${props.params.ludus.zoom}&maptype=${props.params.ludus.mapType}`;

  return (
    <Iframe
      title="Google Maps"
      src={url}
      transitionStatus={props.transitionStatus}
      style={{ ...props.style, opacity: props.groupOpacity }}
      params={props.params}
      applyScaleFix={props.applyScaleFix}
      globalScale={props.globalScale}
      windowHasFocus={props.windowHasFocus}
      groupAngle={props.groupAngle}
      groupScaleX={props.groupScaleX}
      groupScaleY={props.groupScaleY}
      matrixGroup={props.matrixGroup}
    />
  );
};
GoogleMaps.propTypes = {
  style: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ).isRequired,
  params: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.bool,
      PropTypes.func,
      PropTypes.number,
      PropTypes.object,
      PropTypes.string,
    ]),
  ).isRequired,
  applyScaleFix: PropTypes.bool.isRequired,
  globalScale: PropTypes.number.isRequired,
  windowHasFocus: PropTypes.bool.isRequired,
  groupAngle: PropTypes.number.isRequired,
  groupOpacity: PropTypes.number.isRequired,
  groupScaleX: PropTypes.number.isRequired,
  groupScaleY: PropTypes.number.isRequired,
  transitionStatus: PropTypes.string.isRequired,
  matrixGroup: PropTypes.arrayOf(PropTypes.number),
};
GoogleMaps.defaultProps = {
  hyperlink: null,
  matrixGroup: null,
};

export default GoogleMaps;
